import request from '../utils/request'

/**
 * 工作日志相关API
 */

// 获取机器人工作日志列表（分页）
// 注意：robotId 是机器人ID（UUID）
export function getWorkLogList(robotId, params = {}) {
  return request({
    url: `/work_log/list/${robotId}`,
    method: 'get',
    params: {
      page: params.page || 1,
      page_size: params.page_size || 20,
      status: params.status
    }
  })
}

// 获取工作日志详情
export function getWorkLogDetail(logId) {
  return request({
    url: `/work_log/${logId}`,
    method: 'get'
  })
}

// 获取任务关联的工作日志
export function getWorkLogsByTask(taskId) {
  return request({
    url: `/work_log/task/${taskId}`,
    method: 'get'
  })
}

// 获取会话关联的工作日志
export function getWorkLogsBySession(sessionId) {
  return request({
    url: `/work_log/session/${sessionId}`,
    method: 'get'
  })
}

// 创建工作日志
export function createWorkLog(data) {
  return request({
    url: '/work_log/create',
    method: 'post',
    data
  })
}

// 完成工作日志
export function completeWorkLog(logId, data = {}) {
  return request({
    url: `/work_log/complete/${logId}`,
    method: 'post',
    data
  })
}

// 按机器人和时间范围统计工作日志
// 注意：robotId 是机器人ID（UUID）
export function getWorkLogStatsByRobot(robotId, params) {
  return request({
    url: `/work_log/stats/${robotId}`,
    method: 'get',
    params: {
      start_time: params.start_time,
      end_time: params.end_time
    }
  })
}

// 统计当前用户所有机器人的工作日志
export function getMyWorkLogStats(params) {
  return request({
    url: '/work_log/stats/me',
    method: 'get',
    params: {
      start_time: params.start_time,
      end_time: params.end_time
    }
  })
}

// 获取当前用户所有机器人的工作日志列表（分页）
export function getMyWorkLogList(params = {}) {
  return request({
    url: '/work_log/list/me',
    method: 'get',
    params: {
      page: params.page || 1,
      page_size: params.page_size || 20,
      status: params.status,
      start_time: params.start_time,
      end_time: params.end_time
    }
  })
}

export default {
  getWorkLogList,
  getWorkLogDetail,
  getWorkLogsByTask,
  getWorkLogsBySession,
  createWorkLog,
  completeWorkLog,
  getWorkLogStatsByRobot,
  getMyWorkLogStats,
  getMyWorkLogList
}
